// function to encode text to base 64 string
const encodeBase64 = (text : string) => {
    return btoa(text);
}

export default encodeBase64;